import { alpha } from '@mui/material/styles';

const createButtonVariant = ({
  background,
  color = '#ffffff',
  hoverBackground,
  shadowColor,
  border,
}) => ({
  minHeight: 40,
  borderRadius: 6,
  border: border ?? '1px solid transparent',
  background,
  boxShadow: shadowColor ? `0 4px 14px ${shadowColor}` : 'none',
  color,
  fontFamily: 'inherit',
  fontSize: '1.25rem',
  fontWeight: 600,
  letterSpacing: 0,
  lineHeight: 1,
  padding: '0.5rem 2rem',
  textTransform: 'none',
  transition: 'background 180ms ease, box-shadow 180ms ease, transform 180ms ease',
  '&:hover': {
    background: hoverBackground ?? background,
    boxShadow: shadowColor ? `0 6px 20px ${shadowColor}` : 'none',
    transform: 'translateY(-1px)',
  },
  '&:active': {
    boxShadow: shadowColor ? `0 2px 8px ${shadowColor}` : 'none',
    transform: 'translateY(0)',
  },
  '&.Mui-disabled': {
    borderColor: 'transparent',
    background: '#e5e7eb',
    boxShadow: 'none',
    color: '#9ca3af',
  },
});

const createFlatButtonVariant = ({ background, color }) => ({
  minHeight: 40,
  borderRadius: 6,
  border: '1px solid transparent',
  background,
  boxShadow: 'none',
  color,
  fontFamily: 'inherit',
  fontSize: '1.25rem',
  fontWeight: 600,
  letterSpacing: 0,
  lineHeight: 1,
  padding: '0.5rem 2rem',
  textTransform: 'none',
  '&:hover': {
    background,
    boxShadow: 'none',
    color,
  },
  '&.Mui-disabled': {
    background,
    boxShadow: 'none',
    color,
    opacity: 0.75,
  },
});

export const buttonVariants = [
  {
    props: { variant: 'primary' },
    style: createButtonVariant({
      background: 'linear-gradient(135deg, #FF8C00, #FF6000)',
      hoverBackground: 'linear-gradient(135deg, #FF6000, #E55000)',
      shadowColor: alpha('#FF8C00', 0.35),
    }),
  },
  {
    props: { variant: 'success' },
    style: createButtonVariant({
      background: 'linear-gradient(135deg, #22c55e, #16a34a)',
      hoverBackground: 'linear-gradient(135deg, #16a34a, #15803d)',
      shadowColor: alpha('#22c55e', 0.35),
    }),
  },
  {
    props: { variant: 'danger' },
    style: createButtonVariant({
      background: 'linear-gradient(135deg, #ef4444, #dc2626)',
      hoverBackground: 'linear-gradient(135deg, #dc2626, #b91c1c)',
      shadowColor: alpha('#ef4444', 0.35),
    }),
  },
  {
    props: { variant: 'dangerStrong' },
    style: createButtonVariant({
      background: '#E1000C',
      hoverBackground: '#C4000A',
      shadowColor: alpha('#E1000C', 0.28),
    }),
  },
  {
    props: { variant: 'warning' },
    style: createButtonVariant({
      background: 'linear-gradient(135deg, #f59e0b, #d97706)',
      hoverBackground: 'linear-gradient(135deg, #d97706, #b45309)',
      shadowColor: alpha('#f59e0b', 0.35),
    }),
  },
  {
    props: { variant: 'info' },
    style: createButtonVariant({
      background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
      hoverBackground: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
      shadowColor: alpha('#3b82f6', 0.35),
    }),
  },
  {
    props: { variant: 'infoDark' },
    style: createButtonVariant({
      background: 'linear-gradient(180deg, #2459A9, #0045AD)',
      hoverBackground: 'linear-gradient(180deg, #1d4b91, #00398f)',
      shadowColor: alpha('#2459A9', 0.35),
    }),
  },
  {
    props: { variant: 'secondary' },
    style: createButtonVariant({
      background: 'linear-gradient(135deg, #6b7280, #4b5563)',
      hoverBackground: 'linear-gradient(135deg, #4b5563, #374151)',
      shadowColor: alpha('#6b7280', 0.35),
    }),
  },
  {
    props: { variant: 'neutral' },
    style: createButtonVariant({
      background: '#8E8E8E',
      hoverBackground: '#7a7a7a',
      shadowColor: alpha('#8E8E8E', 0.35),
    }),
  },
  {
    props: { variant: 'brand' },
    style: createButtonVariant({
      background: '#004559',
      hoverBackground: '#003747',
      shadowColor: alpha('#004559', 0.35),
    }),
  },
  {
    props: { variant: 'brandSecondary' },
    style: createButtonVariant({
      background: '#ffffff',
      color: '#005972',
      hoverBackground: '#f4fafc',
      border: '1px solid #005972',
    }),
  },
  {
    props: { variant: 'outline' },
    style: createButtonVariant({
      background: 'transparent',
      color: '#FF8C00',
      hoverBackground: alpha('#FF8C00', 0.08),
      border: '2px solid #FF8C00',
    }),
  },
  {
    props: { variant: 'registerPrimary' },
    style: createFlatButtonVariant({
      background: '#005972',
      color: '#ffffff',
    }),
  },
  {
    props: { variant: 'registerSecondary' },
    style: createFlatButtonVariant({
      background: '#ffffff',
      color: '#005972',
    }),
  },
  {
    props: { variant: 'registerDanger' },
    style: createFlatButtonVariant({
      background: '#E1000C',
      color: '#ffffff',
    }),
  },
];
